import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'styled-components'
import { Flex, Box, Image } from 'rebass'
import { Paragraph } from '../Text'

export const ImageRatio = ({ children }) => ( //eslint-disable-line
  <Box
    bg="red"
    css={css`
      margin: 10px;
      position: relative;
      &:after {
        content: '';
        display: block;
        height: 0;
        width: 100%;
        padding-bottom: 100%;
      }
      & > * {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: block;
      }
    `}
  >
    {children}
  </Box>
)

// eslint-disable-next-line
const Label = ({ children }) => (
  <Box mt={-2}>
    <Paragraph
      fontFamily="regular"
      css={{ display: 'inline-block' }}
      color="white"
      bg="red"
      fontSize="8px"
      m={0}
      p="1px"
    >
      {children}
    </Paragraph>
  </Box>
)
// eslint-disable-next-line
const EventText = ({ children, ...rest }) => (
  <Paragraph
    mt={0}
    mb={0}
    fontFamily="regular"
    color="red"
    css={css`
      text-transform: uppercase;
      word-break: break-word;
    `}
    {...rest}
  >
    {children}
  </Paragraph>
)
const cancelledStyle = css`
  background-color: rgba(255, 255, 255, 0.8);
`
// eslint-disable-next-line
const EventCard = ({ small = false, height, title, venue, startDate, endDate, image, cancelled, rescheduled }) => ( 
  <Flex
    width={[1, 1]}
    bg="white"
    pt={small ? 3 : 0}
    justifyContent="flex-start"
    flexDirection="column"
    css={css`
      max-width: 180px;
      width: 100%;
      height: ${height}px;
      border: 1px solid red;
      overflow: hidden;
      ${cancelled ? cancelledStyle : null}
    `}
  >
    {!small && (
      <ImageRatio>
        <Image width={1} {...image} />
      </ImageRatio>
    )}
    <Box px={3}>
      {cancelled ? <Label>Inställd</Label> : null}
      {rescheduled ? <Label>! Ny tid</Label> : null}
      <EventText color="darkerRed" fontSize="9px">
        {startDate}-{endDate}
      </EventText>
      <EventText fontWeight={400} fontSize="11px">
        {title}
      </EventText>
      <EventText color="darkerRed" fontSize="9px">
        {venue}
      </EventText>
    </Box>
  </Flex>
)

EventCard.propTypes = {
  title: PropTypes.string.isRequired,
  venue: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  cancelled: PropTypes.bool,
  rescheduled: PropTypes.bool,
}
export default EventCard
